import { render, staticRenderFns } from "./v-quill-editor.vue?vue&type=template&id=687ac66c&scoped=true&"
import script from "./v-quill-editor.vue?vue&type=script&lang=js&"
export * from "./v-quill-editor.vue?vue&type=script&lang=js&"
import style0 from "./v-quill-editor.vue?vue&type=style&index=0&id=687ac66c&lang=scss&scoped=true&"
import style1 from "./v-quill-editor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687ac66c",
  null
  
)

export default component.exports